__turbopack_context__.v({
  "header": "style-module-scss-module__xOTNma__header",
  "headerFixed": "style-module-scss-module__xOTNma__headerFixed",
});
